import React, { Suspense, lazy } from 'react';
import MainLoader from '~components/main-loader';

const RiskCardPage = lazy(() => import('./index.js'))

function RiskCardPageLazy(props) {
    return (
        <Suspense fallback={<MainLoader />}>
            <RiskCardPage {...props} />
        </Suspense>
    );
}

export default RiskCardPageLazy;
export { RiskCardPageLazy };



// WEBPACK FOOTER //
// ./src/routes/main/risk-card-page/lazy.js